import { action, createRequestTypes } from '../base';

export const shopifyIntegrationActionTypes = {
  CONNECT_TO_SHOPIFY: createRequestTypes('CONNECT_TO_SHOPIFY'),
  DELETE_SHOPIFY_CONNECTION: createRequestTypes('DELETE_SHOPIFY_CONNECTION'),
  GET_SHOPIFY_CONNECTIONS: createRequestTypes('GET_SHOPIFY_CONNECTIONS'),
  CONNECT_TENANT_TO_SHOPIFY_LOCATION: createRequestTypes('CONNECT_TENANT_TO_SHOPIFY_LOCATION'),
  UPDATE_SHOPIFY_CONFIGURATION: createRequestTypes('UPDATE_SHOPIFY_CONFIGURATION'),
  SYNC_SHOPIFY_INVENTORY: createRequestTypes('SYNC_SHOPIFY_INVENTORY'),
  SYNC_SHOPIFY_CUSTOMER: createRequestTypes('SYNC_SHOPIFY_CUSTOMER'),
  SYNC_SHOPIFY_SO: createRequestTypes('SYNC_SHOPIFY_SO'),
  SYNC_SHOPIFY_ORDERS: createRequestTypes('SYNC_SHOPIFY_ORDERS'),
  CANCEL_SHOPIFY_ORDER: createRequestTypes('CANCEL_SHOPIFY_ORDER'),
  CREATE_ADHOC: createRequestTypes('CREATE_ADHOC'),
};

/**
 * @param payload
 * @param callback
 * @param orgId
 */
class ShopifyIntegrationActions {
  getShopifyConnections = (orgId, callback) => action(shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.REQUEST, {
    orgId, callback,
  })

  /**
   *
   * @param {*} getShopifyConnectionsLoading
   * @return
   */
  getShopifyConnectionsLoading = (getShopifyConnectionsLoading) => action(shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.LOADING, {
    getShopifyConnectionsLoading,
  })

  /**
  * @return
  * @param linkedDaData
  */
  getShopifyConnectionsSuccess = (shopifyConnections) => action(shopifyIntegrationActionTypes.GET_SHOPIFY_CONNECTIONS.SUCCESS, {
    shopifyConnections,
  })

  /**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
  deleteShopifyConnection = (payload, callback) => action(shopifyIntegrationActionTypes.DELETE_SHOPIFY_CONNECTION.REQUEST, {
    payload, callback,
  })

/**
*
* @param {*} deleteShopifyConnectionLoading
* @returns
*/
deleteShopifyConnectionLoading = (deleteShopifyConnectionLoading) => action(shopifyIntegrationActionTypes.DELETE_SHOPIFY_CONNECTION.LOADING, {
  deleteShopifyConnectionLoading,
})

/**
* @return
* @param payload
* @param callback
*/
connectToShopify = (payload, callback) => action(shopifyIntegrationActionTypes.CONNECT_TO_SHOPIFY.REQUEST, {
  payload, callback,
})

/**
* @return
* @param connectToShopifyLoading
*/
connectToShopifyLoading = (connectToShopifyLoading) => action(shopifyIntegrationActionTypes.CONNECT_TO_SHOPIFY.LOADING, {
  connectToShopifyLoading,
})

/**
 * @param {*} payload
 * @param callback
 * @return
 */
connectTenantToShopifyLocation = (payload, callback) => action(shopifyIntegrationActionTypes.CONNECT_TENANT_TO_SHOPIFY_LOCATION.REQUEST, {
  payload, callback,
})

/**
* @return
* @param connectTenantToShopifyLocationLoading
*/
connectTenantToShopifyLocationLoading = (connectTenantToShopifyLocationLoading) => action(shopifyIntegrationActionTypes.CONNECT_TENANT_TO_SHOPIFY_LOCATION.LOADING, {
  connectTenantToShopifyLocationLoading,
})

/**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
updateShopifyConfiguration = (payload, callback) => action(shopifyIntegrationActionTypes.UPDATE_SHOPIFY_CONFIGURATION.REQUEST, {
  payload, callback,
})

/**
*
* @param {*} updateShopifyConfigurationLoading
* @returns
*/
updateShopifyConfigurationLoading = (updateShopifyConfigurationLoading) => action(shopifyIntegrationActionTypes.UPDATE_SHOPIFY_CONFIGURATION.LOADING, {
  updateShopifyConfigurationLoading,
})

/**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
syncShopifyInventory = (payload, callback) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_INVENTORY.REQUEST, {
  payload, callback,
})

/**
*
* @param {*} syncShopifyInventoryLoading
* @returns
*/
syncShopifyInventoryLoading = (syncShopifyInventoryLoading) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_INVENTORY.LOADING, {
  syncShopifyInventoryLoading,
})

/**
*
* @param {*} payload
* @param {*} callback
* @returns
*/
syncShopifyCustomer = (payload, callback) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_CUSTOMER.REQUEST, {
  payload, callback,
})

/**
*
* @param {*} syncShopifyCustomerLoading
* @returns
*/
syncShopifyCustomerLoading = (syncShopifyCustomerLoading) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_CUSTOMER.LOADING, {
  syncShopifyCustomerLoading,
})

/**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
  syncShopifySO = (payload, callback) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_SO.REQUEST, {
    payload, callback,
  })

/**
*
* @param {*} syncShopifySOLoading
* @returns
*/
syncShopifySOLoading = (syncShopifySOLoading) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_SO.LOADING, {
  syncShopifySOLoading,
})

/**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
  syncShopifyOrders = (payload, callback) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_ORDERS.REQUEST, {
    payload, callback,
  })

/**
*
* @param {*} syncShopifyOrdersLoading
* @returns
*/
syncShopifyOrdersLoading = (syncShopifyOrdersLoading) => action(shopifyIntegrationActionTypes.SYNC_SHOPIFY_ORDERS.LOADING, {
  syncShopifyOrdersLoading,
})

/**
 * @param payload
 * @param callback
 * @return {{type: *}}
 */
 cancelShopifyOrder = (payload, callback) => action(shopifyIntegrationActionTypes.CANCEL_SHOPIFY_ORDER.REQUEST, {
   payload, callback,
 })

 /**
 * @param cancelShopifyOrderLoading
 * @return {{type: *}}
 */
  cancelShopifyOrderLoading = (cancelShopifyOrderLoading) => action(shopifyIntegrationActionTypes.CANCEL_SHOPIFY_ORDER.LOADING, {
    cancelShopifyOrderLoading,
  })

  /**
 * @param {*} payload
 * @param callback
 * @return
 */
createADHOC = (payload, callback) => action(shopifyIntegrationActionTypes.CREATE_ADHOC.REQUEST, {
  payload, callback,
})

/**
 * @param createADHOCLoading
 * @return {{type: *}}
 */
   createADHOCLoading = (createADHOCLoading) => action(shopifyIntegrationActionTypes.CREATE_ADHOC.LOADING, {
     createADHOCLoading,
   })
}

export default new ShopifyIntegrationActions();
